import { useState } from 'react';
import { api, usd } from '../lib/api';
import { ErrorNote, Modal, useLoad } from '../components/ui';

export default function GiftCards() {
  const data = useLoad(() => api<{ cards: any[]; outstandingCents: number }>('/api/gift-cards'), []);
  const [selling, setSelling] = useState(false);
  const [sold, setSold] = useState<any>(null);
  const [err, setErr] = useState<unknown>(null);
  return (
    <div className="stack">
      <div className="page-head">
        <div className="grow"><h1>Gift cards</h1><p>Gift cards are money you owe customers, not sales. They are not taxed when sold; the sale is recorded when they are spent. Outstanding balance: <b>{usd(data.data?.outstandingCents ?? 0)}</b>.</p></div>
        <button className="primary" onClick={() => setSelling(true)}>Sell a gift card</button>
      </div>
      <ErrorNote error={data.error ?? err} />
      <div className="panel"><div className="table-wrap">
        <table className="grid">
          <thead><tr><th>Card</th><th>Sold</th><th className="n">Original</th><th className="n">Balance</th><th>Status</th><th /></tr></thead>
          <tbody>{data.data?.cards.map((c) => (
            <tr key={c.id}>
              <td className="num">{c.code}</td><td>{new Date(c.created_at).toLocaleDateString()}</td>
              <td className="n">{usd(c.initial_cents)}</td><td className="n">{usd(c.balance_cents)}</td>
              <td><span className={`chip ${c.active ? 'good' : 'bad'}`}>{c.active ? 'active' : 'off'}</span></td>
              <td><button onClick={async () => { setErr(null); try { await api(`/api/gift-cards/${encodeURIComponent(c.code)}/active`, { body: { active: !c.active } }); data.reload(); } catch (e) { setErr(e); } }}>{c.active ? 'Switch off' : 'Switch on'}</button></td>
            </tr>))}</tbody>
        </table>
        {data.data?.cards.length === 0 && <div className="empty">No gift cards sold yet.</div>}
      </div></div>
      {selling && <SellCard onClose={() => setSelling(false)} onDone={(card) => { setSelling(false); setSold(card); data.reload(); }} />}
      {sold && (
        <Modal title="Gift card sold" onClose={() => setSold(null)} footer={<button className="primary" onClick={() => setSold(null)}>Done</button>}>
          <p>Card number <b className="num">{sold.code}</b></p>
          <p>Balance <b>{usd(sold.balance_cents)}</b></p>
        </Modal>
      )}
    </div>
  );
}

function SellCard({ onClose, onDone }: { onClose: () => void; onDone: (card: any) => void }) {
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState<'cash' | 'card'>('card');
  const [code, setCode] = useState('');
  const [err, setErr] = useState<unknown>(null);
  const cents = Math.round(Number(amount) * 100);
  return (
    <Modal title="Sell a gift card" onClose={onClose} footer={<button className="primary" disabled={!(cents > 0)} onClick={async () => {
      try { onDone(await api('/api/gift-cards', { body: { amountCents: cents, method, ...(code.trim() ? { code } : {}) } })); } catch (e) { setErr(e); }
    }}>Sell for {cents > 0 ? usd(cents) : '…'}</button>}>
      <ErrorNote error={err} />
      <div className="field-row">
        <label>Amount<input autoFocus className="num-input" inputMode="decimal" value={amount} onChange={(e) => setAmount(e.target.value.replace(/[^\d.]/g, ''))} placeholder="0.00" /></label>
        <label>Paid by<select value={method} onChange={(e) => setMethod(e.target.value as 'cash' | 'card')}><option value="card">Card</option><option value="cash">Cash</option></select></label>
      </div>
      <label>Card number (scan a pre-printed card, or leave blank to make one)<input value={code} onChange={(e) => setCode(e.target.value)} /></label>
    </Modal>
  );
}
